/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Marketing_DescriptionInputs */

const en_wb_marketing_description = /** @type {(inputs: Wb_Marketing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review the findings and the context before sharing the report with your team.`)
};

const lv_wb_marketing_description = /** @type {(inputs: Wb_Marketing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pārbaudiet secinājumus un kontekstu, pirms dalāties ar atskaiti komandā.`)
};

/**
* | output |
* | --- |
* | "Review the findings and the context before sharing the report with your team." |
*
* @param {Wb_Marketing_DescriptionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_marketing_description = /** @type {((inputs?: Wb_Marketing_DescriptionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Marketing_DescriptionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_marketing_description(inputs)
	return en_wb_marketing_description(inputs)
});